/**
 *
 * SearchBar
 *
 */
import * as React from 'react';
import styled from 'styled-components/macro';
import { TextField, InputAdornment } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons';

interface Props {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  fullWidth?: boolean;
}

export function SearchBar(props: Props) {
  const { placeholder = "Search...", value, onChange, fullWidth = true } = props;

  return (
    <SearchContainer>
      <TextField
        fullWidth={fullWidth}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <FontAwesomeIcon icon={faSearch} style={{ color: '#FF74E9' }} />
            </InputAdornment>
          ),
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            color: '#FFFFFF',
            backgroundColor: 'transparent',
            borderRadius: '15px',
            paddingLeft: '12px',
            borderColor: 'rgba(100, 82, 112, 1)',
            borderWidth: '1px',
            borderStyle: 'solid',
            '&:hover': {
              borderColor: '#FF74E9',
              borderWidth: '1px',
              borderStyle: 'solid',
              borderRadius: '15px',
            },
            '& fieldset': {
              border: 'none',
            },
            '&:hover fieldset': {
              border: 'none',
            },
            '&.Mui-focused fieldset': {
              border: 'none',
            },
          },
          '& .MuiInputBase-input::placeholder': {
            color: '#f5e1ff',
            opacity: 0.7,
          },
        }}
      />
    </SearchContainer>
  );
}

const SearchContainer = styled.div`
  margin: 16px 0 -16px 0;
  padding: 0;
  
  @media only screen and (max-width: 600px) {
    margin: 12px 0 -12px 0;
    padding: 0;
  }
`;
